import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/render/project/src/apps/storefront/app/components/RestaurantLocation.tsx");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/apps/storefront/app/favicon.ico");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/libs/context-i18n/src/lib/context-i18n.tsx");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/libs/ui-system-next/src/assets/avocado.svg");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/libs/ui-system-next/src/lib/CheckmarkButton/checkmark-button.tsx");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/libs/ui-system-next/src/lib/close-icon/close-icon.tsx");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/libs/ui-system-next/src/lib/code-input/code-input.tsx");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/libs/ui-system-next/src/lib/currency-input/currency-input.tsx");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/libs/ui-system-next/src/lib/date-picker/date-picker.tsx");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/libs/ui-system-next/src/lib/dropdown/dropdown.tsx");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/libs/ui-system-next/src/lib/dropzone-area/dropzone-area.tsx");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/libs/ui-system-next/src/lib/expandable-text/expandable-text.tsx");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/libs/ui-system-next/src/lib/file-upload/file-upload.tsx");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/libs/ui-system-next/src/lib/hooks/use-controllable-state.ts");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/libs/ui-system-next/src/lib/image-crop/image-crop.tsx");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/libs/ui-system-next/src/lib/image-upload/image-upload.tsx");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/libs/ui-system-next/src/lib/image-with-fallback/image-with-fallback.tsx");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/libs/ui-system-next/src/lib/inline-auth/inline-auth.tsx");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/libs/ui-system-next/src/lib/label/label.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AnimatedLogo"] */ "/opt/render/project/src/libs/ui-system-next/src/lib/loading/animated-logo.tsx");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/libs/ui-system-next/src/lib/map/map.tsx");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/libs/ui-system-next/src/lib/modal/modal.tsx");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/libs/ui-system-next/src/lib/page-nav/page-nav.tsx");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/libs/ui-system-next/src/lib/phone-input/phone-input.tsx");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/libs/ui-system-next/src/lib/selection-group/selection-group.tsx");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/libs/ui-system-next/src/lib/tabs/tabs.tsx");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/libs/ui-system-next/src/lib/time-input/time-input.tsx");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/libs/ui-system-next/src/lib/tip-selector/tip-selector.tsx");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/libs/ui-system-next/src/lib/url-bar/url-bar.tsx");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/libs/ui-system-next/src/lib/user-menu/user-menu.tsx");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/libs/ui-system-next/src/lib/wizard/wizard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Portal","Overlay","Content","Title","Description","Root","Trigger","Action","Cancel"] */ "/opt/render/project/src/node_modules/@radix-ui/react-alert-dialog/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/node_modules/next/dist/client/image-component.js");
